import {
  ColDef,
  ICellRendererParams,
  ValueGetterParams,
} from 'ag-grid-community';
import {
  createAdministratorNameCol,
  createCustomCol,
  createDateHasMinCol,
  createIdCol,
  createStatusBadgeCol,
  createTypoCol,
} from '@/src/helpers/agColumnHelper';
import Button from '@/src/components/atom/Button';

export const listColumn = (
  onDetailClick: (id: number) => void,
  getContentName: (key: string) => string,
): ColDef[] => [
  createIdCol(),
  createDateHasMinCol({
    field: 'createdAt',
    width: 231,
    minWidth: 231,
    maxWidth: 300,
    headerClass: 'ag-right-aligned-cell',
    size: 'md',
    headerName: '등록 일시',
  }),
  createTypoCol({
    field: 'title',
    size: 'lg',
    flex: 2,
    headerName: '제목',
  }),
  createCustomCol({
    field: 'contentType',
    size: 'md',
    cellRenderer: (params: ValueGetterParams) => {
      return params?.data ? getContentName(params.data.content) : '-';
    },
    headerName: '연결 컨텐츠',
  }),
  createStatusBadgeCol({
    field: 'isExposed',
    type: 'isExposed',
    size: 'sm',
    headerName: '노출 여부',
  }),
  createStatusBadgeCol({
    field: 'isExposeNewBadge',
    type: 'isExposed',
    size: 'sm',
    headerName: '뱃지 노출 여부',
  }),
  createAdministratorNameCol({
    headerName: '등록 관리자',
  }),
  {
    field: 'detail',
    lockPosition: 'right',
    pinned: 'right',
    headerName: '조회',
    headerClass: 'ag-right-aligned-cell',
    width: 129,
    minWidth: 129,
    maxWidth: 129,
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    cellRenderer: ({ data }: ICellRendererParams) => {
      return (
        <Button
          buttonSize="xSmall"
          buttonColor="outline"
          onClick={() => onDetailClick(data.id as number)}
        >
          상세보기
        </Button>
      );
    },
  },
  // createDetailButtonCol(onDetailClick),
];
